var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "igc-ad" },
    [
      _vm.mossAds.length == 1
        ? _c("div", { staticClass: "sui-swiper" }, [
            _c("ul", { staticStyle: { width: "100%" } }, [
              _c("li", { staticStyle: { width: "100%" } }, [
                _c(
                  "a",
                  {
                    style:
                      "background-image:url(" + _vm.mossAds[0].images + ")",
                    attrs: { href: "javascript:;" },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.report(_vm.mossAds[0])
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "ig--title" }, [
                      _vm._v(_vm._s(_vm.mossAds[0].title))
                    ])
                  ]
                )
              ])
            ])
          ])
        : _vm._e(),
      _vm.mossAds.length > 1
        ? _c("sui-swiper", {
            attrs: { "key-name": "id", list: _vm.mossAds, autoPlay: true },
            on: { change: _vm.changeSwiper },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _c(
                        "a",
                        {
                          style: "background-image:url(" + item.images + ")",
                          attrs: { href: "javascript:;" },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.report(item)
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "ig--title" }, [
                            _vm._v(_vm._s(item.title))
                          ])
                        ]
                      )
                    ]
                  }
                }
              ],
              null,
              false,
              292957739
            )
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }